import { createRouter } from "./routes";
import { RouterProvider } from "react-router-dom";
import MainProvider from "./main-provider";

const AppRouter = () => {
  return <RouterProvider router={createRouter} />;
};

function App() {
  return (
    <MainProvider>
      <AppRouter />
    </MainProvider>
  );
}

export default App;
